<template>
  <div class="p-gallery">
    <section class="m-site-hero m-site-hero--gallery" :class="activeGender">
      <div class="m-site-hero__wrapper">
        <h1 v-if="activeGender === 'male'" class="m-site-hero__title">
          உங்கள் குடும்பத்திற்கு ஏற்ற மருமகனை கண்டறிய உதவுகிறோம்.
        </h1>
        <h1 v-else class="m-site-hero__title">
          உங்கள் குடும்பத்திற்கு ஏற்ற மருமகளை கண்டறிய உதவுகிறோம்.
        </h1>

        <div class="m-site-hero__cta m-cta">
          <div class="m-cta__card">
            <p class="m-cta__cost">
              ஒரு முறை பதிவு கட்டணம்
              <span class="u-number-font">₹500</span> மட்டுமே.
            </p>
            <div class="m-cta__btn-wrapper">
              <button
                class="m-btn m-btn--primary m-btn--hero m-cta__btn"
                @click="gotoRegistration()"
              >
                பதிவு செய்க
              </button>

              <button class="m-btn m-btn--green m-btn--hero m-btn--link m-cta__btn" @click="goToWhatsApp()">வாட்ஸாப்</button>
            </div>
            <p class="m-cta__terms">இன்றே இணைந்திடுங்கள்.</p>
          </div>
        </div>
      </div>
    </section>

    <section
      ref="filters"
      class="p-gallery__filters"
      :class="{ 'filters-visible': filtersVisible }"
    >
      <ip-search ipType="number" placeholder="உறுப்பினர் ஐடி மூலம் தேடவும்" />

      <ip-select
        class="collapsible"
        :options="casteOptions"
        placeholder="சாதி"
        v-model="activeCaste"
        @input="setActiveCaste"
      />

      <ip-select
        class="collapsible"
        placeholder="துணை-சாதி"
        :options="subcasteOptions"
        v-model="activeSubcaste"
        @input="setActiveSubcaste"
      />

      <ip-select
        class="collapsible raasi"
        placeholder="இராசி"
        :options="raasiOptions"
        v-model="activeRaasi"
        @input="setActiveRaasi"
      />

      <ip-select
        class="collapsible star"
        placeholder="நட்சத்திரம்"
        :options="starOptions"
        v-model="activeStar"
        @input="setActiveStar"
      />

      <ip-select
        class="collapsible salary"
        placeholder="மாத வருமானம்"
        :options="salaryOptions"
        v-model="activeSalary"
        @input="setActiveSalary"
      />
    </section>

    <div class="p-gallery__filter-btns-wrapper">
      <button
        class="m-btn"
        :class="{ 'u-display-none': filtersVisible }"
        style="padding: 6px 10px"
        @click="toggleFiltersVisibility"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17 9.16994C16.8126 8.98369 16.5592 8.87915 16.295 8.87915C16.0308 8.87915 15.7774 8.98369 15.59 9.16994L12 12.7099L8.46 9.16994C8.27264 8.98369 8.01919 8.87915 7.755 8.87915C7.49082 8.87915 7.23736 8.98369 7.05 9.16994C6.95627 9.26291 6.88188 9.37351 6.83111 9.49537C6.78034 9.61723 6.7542 9.74793 6.7542 9.87994C6.7542 10.012 6.78034 10.1427 6.83111 10.2645C6.88188 10.3864 6.95627 10.497 7.05 10.5899L11.29 14.8299C11.383 14.9237 11.4936 14.9981 11.6154 15.0488C11.7373 15.0996 11.868 15.1257 12 15.1257C12.132 15.1257 12.2627 15.0996 12.3846 15.0488C12.5064 14.9981 12.617 14.9237 12.71 14.8299L17 10.5899C17.0937 10.497 17.1681 10.3864 17.2189 10.2645C17.2697 10.1427 17.2958 10.012 17.2958 9.87994C17.2958 9.74793 17.2697 9.61723 17.2189 9.49537C17.1681 9.37351 17.0937 9.26291 17 9.16994Z"
            fill="#989898"
          />
        </svg>
        வடிகட்டிகளை காட்டு
      </button>

      <button
        class="m-btn"
        :class="{ 'u-display-none': !filtersVisible }"
        style="padding: 6px 10px"
        @click="toggleFiltersVisibility"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17 13.4101L12.71 9.17007C12.617 9.07634 12.5064 9.00194 12.3846 8.95117C12.2627 8.90041 12.132 8.87427 12 8.87427C11.868 8.87427 11.7373 8.90041 11.6154 8.95117C11.4936 9.00194 11.383 9.07634 11.29 9.17007L7.05001 13.4101C6.95628 13.503 6.88189 13.6136 6.83112 13.7355C6.78035 13.8573 6.75421 13.9881 6.75421 14.1201C6.75421 14.2521 6.78035 14.3828 6.83112 14.5046C6.88189 14.6265 6.95628 14.7371 7.05001 14.8301C7.23737 15.0163 7.49082 15.1209 7.75501 15.1209C8.0192 15.1209 8.27265 15.0163 8.46001 14.8301L12 11.2901L15.54 14.8301C15.7263 15.0148 15.9777 15.119 16.24 15.1201C16.3716 15.1208 16.5021 15.0956 16.6239 15.0458C16.7458 14.9961 16.8566 14.9227 16.95 14.8301C17.0471 14.7404 17.1254 14.6325 17.1805 14.5124C17.2357 14.3923 17.2664 14.2625 17.2711 14.1305C17.2757 13.9985 17.2542 13.8668 17.2076 13.7432C17.1611 13.6195 17.0905 13.5063 17 13.4101Z"
            fill="#989898"
          />
        </svg>
        வடிகட்டிகளை மறைத்திடு
      </button>
    </div>

    <div
      class="p-gallery__segmented-control m-segmented-control"
      :class="{
        'p-gallery__segmented-control--female': activeGender === 'female',
        'p-gallery__segmented-control--male': activeGender === 'male',
      }"
    >
      <span class="m-segmented-control__option" @click="switchToFemale"
        >பெண்கள்</span
      >
      <span class="m-segmented-control__option" @click="switchToMale"
        >ஆண்கள்</span
      >
    </div>

    <h3 class="p-gallery__page-title" v-html="pageTitle"></h3>

    <section
      ref="cards_wrapper"
      class="p-gallery__cards-wrapper"
      :class="{ 'is-loading': isLoading }"
    >
      <card
        v-for="card in cardsResponse.results"
        :key="card.id"
        :card="card"
        :cardImage="card.card_image"
      />
      <div
        v-if="!cardsResponse.results.length"
        style="padding-block: 32px 16px"
      >
        <p>பொருத்தமான வரன்கள் எதுவும் கிடைக்கவில்லை.</p>
      </div>
    </section>

    <div class="p-gallery__pagination">
      <pagination :current="currentPage" :total="totalPages" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Card from "@/components/Card.vue";
import IpSearch from "@/components/IpSearch.vue";
import IpSelect from "@/components/IpSelect.vue";
import Pagination from "@/components/Pagination.vue";
import filterCasteMixin from "@/mixins/filterCasteMixin.js";
import filterSubcasteMixin from "@/mixins/filterSubcasteMixin.js";
import filterRaasiMixin from "@/mixins/filterRaasiMixin.js";
import filterStarMixin from "@/mixins/filterStarMixin.js";
import filterSalaryMixin from "@/mixins/filterSalaryMixin.js";

export default {
  name: "Gallery",
  components: {
    Card,
    IpSearch,
    IpSelect,
    Pagination,
  },
  mixins: [
    filterCasteMixin,
    filterSubcasteMixin,
    filterRaasiMixin,
    filterStarMixin,
    filterSalaryMixin,
  ],
  data() {
    return {
      isLoading: true,
      activeTagSlug: this.$route.params.tag || null,
      activeTag: null,
      activeGender: this.$route.params.gender || "female",
      castes: [],
      subcastes: [],
      stars: [],
      raasis: [],
      salaryOptions: [
        { label: "< 30 ஆயிரம்", value: "lt30" },
        { label: "30-50 ஆயிரம்", value: "30to50" },
        { label: "50 ஆயிரம் - 1 லட்சம்", value: "50to100" },
        { label: "> 1 லட்சம்", value: "gt100" },
      ],
      cardsResponse: {
        count: 0,
        next: null,
        previous: null,
        results: [],
      },
      currentPage: parseInt(this.$route.query.page) || 1,
      pageSize: 12,
      pageTitle: null,
      filtersVisible: false, // for mobile view
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.cardsResponse.count / this.pageSize) || 1;
    },
    casteOptions() {
      let options = [];
      this.castes.forEach((caste) => {
        options.push({ label: caste.name, value: caste.id });
      });
      return options;
    },
    subcasteOptions() {
      let options = [];

      if (!this.activeCaste) {
        return;
      }

      this.subcastes.forEach((caste) => {
        if (caste.parent.toString() === this.activeCaste) {
          options.push({ label: caste.name, value: caste.id });
        }
      });
      return options;
    },
    starOptions() {
      let options = [];
      this.stars.forEach((star) => {
        options.push({ label: star.value, value: star.key });
      });
      return options;
    },
    raasiOptions() {
      let options = [];
      this.raasis.forEach((raasi) => {
        options.push({ label: raasi.value, value: raasi.key });
      });
      return options;
    },
    filterButtonsVisible() {
      return window.innerWidth < 768;
    },
  },
  methods: {
    toggleFiltersVisibility() {
      this.filtersVisible = !this.filtersVisible;

      const self = this;
      if (this.filtersVisible) {
        setTimeout(function () {
          self.$refs.filters.style.overflow = "visible";
        }, 400);
      } else {
        self.$refs.filters.style = "";
      }
    },
    switchToFemale() {
      if (this.activeGender !== "female") {
        const params = Object.assign({}, this.$route.params, {
          gender: "female",
        });
        const query = Object.assign({}, this.$route.query, { page: 1 });
        this.$router.push({
          name: this.$route.name,
          params: params,
          query: query,
        });
      }
    },
    switchToMale() {
      if (this.activeGender !== "male") {
        const params = Object.assign({}, this.$route.params, {
          gender: "male",
        });
        const query = Object.assign({}, this.$route.query, { page: 1 });
        this.$router.push({
          name: this.$route.name,
          params: params,
          query: query,
        });
      }
    },
    gotoRegistration() {
      location.href = "/ta/register";
    },
    goToWhatsApp() {
      window.open("https://wa.me/916369286741?text=REGISTER", "_blank");
    },
    getCards() {
      let url = "/api/profiles/";

      const queryParams = {
        page: parseInt(this.$route.query.page) || 1,
        gender: this.$route.params.gender || "female",
        caste: parseInt(this.$route.query.caste) || null,
        subcaste: parseInt(this.$route.query.subcaste) || null,
        raasi: this.$route.query.raasi || null,
        star: this.$route.query.star || null,
      };

      if (this.$route.query.salary) {
        switch (this.$route.query.salary) {
          case "lt30":
            queryParams["maxsalary"] = 29999;
            break;

          case "30to50":
            queryParams["minsalary"] = 30000;
            queryParams["maxsalary"] = 49999;
            break;

          case "50to100":
            queryParams["minsalary"] = 50000;
            queryParams["maxsalary"] = 99999;
            break;

          case "gt100":
            queryParams["minsalary"] = 100000;
        }
      }

      if (this.$route.params.tag) {
        queryParams["tag"] = this.$route.params.tag;
      }

      for (const param in queryParams) {
        if (
          param === "gender" &&
          ["male", "female"].indexOf(queryParams[param]) === -1
        ) {
          queryParams[param] = "female";
        }

        if (queryParams[param] === null) {
          delete queryParams[param];
        }
      }

      url += "?" + new URLSearchParams(queryParams).toString();

      this.isLoading = true;

      axios
        .get(url)
        .then((response) => {
          this.cardsResponse = response.data;

          let scrollTop = this.$refs.filters.offsetTop;

          if (window.innerWidth < 768) {
            scrollTop = scrollTop - 80; // mobile site-header height is 80px;
          }

          window.scrollTo(0, scrollTop);
        })
        .catch((err) => {
          console.error(`Error fetching cards: ${err}`);

          this.cardsResponse = {
            count: 0,
            next: null,
            previous: null,
            results: [],
          };
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getCasteList() {
      axios.get("/api/profiles/caste/").then((response) => {
        this.castes = response.data;
      });
    },
    getSubcasteList() {
      axios.get("/api/profiles/subcaste/").then((response) => {
        this.subcastes = response.data;
      });
    },
    getRaasiList() {
      axios.get("/api/profiles/raasi/").then((response) => {
        this.raasis = response.data;
      });
    },
    getStarList() {
      axios.get("/api/profiles/star/").then((response) => {
        this.stars = response.data;
      });
    },
    getTagInfo() {
      if (!this.activeTagSlug) {
        return;
      }

      return axios.get(`/api/tags/${this.activeTagSlug}/`).then((response) => {
        this.activeTag = response.data;
      });
    },
    updateDocTitle() {
      let title = "பெண்கள்";
      if (this.activeGender === "male") {
        title = "ஆண்கள்";
      }

      if (this.activeTag) {
        title += ` [${this.activeTag.name}]`;
      }

      document.title = `${title} | காஞ்சி திருமண தகவல் மையம் | Kanchi Matrimony`;
    },
    updatePageTitle() {
      let gender = "பெண்கள்";
      if (this.activeGender === "male") {
        gender = "ஆண்கள்";
      }

      if (this.activeTag) {
        this.pageTitle = `<span class="m-tag m-tag--${this.activeTag.slug}">"${this.activeTag.name}"</span> என குறிக்கப்பட்டுள்ள ${gender}`;
      } else {
        this.pageTitle = gender;
      }
    },
  },
  mounted() {
    this.currentPage = parseInt(this.$route.query.page) || 1;

    if (this.activeTagSlug) {
      this.getTagInfo().finally(() => {
        this.updateDocTitle();
        this.updatePageTitle();
      });
    } else {
      this.updateDocTitle();
      this.updatePageTitle();
    }

    this.getCards();
    this.getCasteList();
    this.getSubcasteList();
    this.getRaasiList();
    this.getStarList();
  },
  watch: {
    $route() {
      this.activeTagSlug = this.$route.params.tag || null;
      this.activeGender = this.$route.params.gender || "female";
      this.currentPage = parseInt(this.$route.query.page) || 1;
      this.activeCaste = this.$route.query.caste || null;
      this.activeSubcaste = this.$route.query.subcaste || null;
      this.activeStar = this.$route.query.star || null;
      this.activeRaasi = this.$route.query.raasi || null;
      this.activeSalary = this.$route.query.salary || null;

      this.getCards();
    },
    activeTagSlug(newValue) {
      if (newValue) {
        this.getTagInfo().then(() => {
          this.updateDocTitle();
          this.updatePageTitle();
        });
      } else {
        this.activeTag = null;
        this.updateDocTitle();
        this.updatePageTitle();
      }
    },
    activeGender() {
      this.updatePageTitle();
      this.updateDocTitle();
    },
  },
};
</script>

<style lang="scss">
@import "@/scss/p-gallery";
</style>
